const APP_BASE_PATH = import.meta.env.VITE_BASE || "/";
const ROUTES = {
  LOGIN: "/login",
  HOME: "/home",
};
export { APP_BASE_PATH, ROUTES };
